import React, { useEffect } from "react";
import imgBlue from "../../assets/2.png";
import { useTranslation } from "react-i18next";
import { indexStore } from "../../store/indexStore";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "../ui/sheet";
import { Menu } from "lucide-react";

import Spacer from "../Spacer";
import i18n from "../../i18n";
import uaeFlag from "../../assets/uae-flag.png";
import usaFlag from "../../assets/usa-flag.png";

function HeaderPage() {
  const { t } = useTranslation();
  const { lang, changeLang } = indexStore();
  const linkClassName = " text-lg capitalize";
  // const handelSelectChange = (e: any) => {
  //   changeLang(e);
  // };
  useEffect(() => {
    const handleLanguageChange = () => {
      i18n.changeLanguage(lang);
      document.documentElement.dir = i18n.dir();
    };

    if (lang) {
      handleLanguageChange();
    } else {
      changeLang(localStorage.getItem("Lang") || "en");
    }
  }, [lang]);
  const toggleLanguage = () => {
    changeLang(lang === "ar" ? "en" : "ar");
  };
  return (
    <div className="grid grid-cols-3 items-center shadow-sm px-4 relative">
      <a href="/" className="">
        <img width={150} height={100} src={imgBlue} alt="cl" className="p-2" />
      </a>

      <div className={` hidden md:flex gap-7  items-center `}>
        <a className={linkClassName} href="/">
          {t("pages.home")}
        </a>
        <a className={linkClassName} href="/features">
          {t("pages.features")}
        </a>
        <a className={linkClassName} href="/services">
          {t("pages.services")}
        </a>
        <a className={linkClassName} href="/pricing">
          {t("pages.pricing")}
        </a>
        <a className={linkClassName} href="/contact">
          {t("pages.contact")}
        </a>
      </div>

      <div
        className={
          " gap-2 hidden md:flex items-center cursor-pointer justify-end"
        }
      >
        <LangButtonToggle language={lang} toggleLanguage={toggleLanguage} />
      </div>
      <Spacer className="md:hidden" flex={true} />

      <div className="md:hidden flex items-center gap-2 justify-end">
        <LangButtonToggle language={lang} toggleLanguage={toggleLanguage} />

        <Sheet>
          <SheetTrigger asChild>
            <div className="flex gap-2 justify-end items-center">
              <Menu />
            </div>
          </SheetTrigger>

          <SheetContent side={`${lang === "ar" ? "left" : "right"}`}>
            <SheetHeader>
              <SheetTitle className="text-MainBlue">
                {t("pages.menu")}
              </SheetTitle>
            </SheetHeader>
            <div className={`flex  flex-col  `}>
              <a
                className={`${linkClassName} bg-muted border-b-1 p-4`}
                href="/"
              >
                {t("pages.home")}
              </a>
              <a
                className={`${linkClassName}  bg-muted border-b-1 p-4`}
                href="/features"
              >
                {t("pages.features")}
              </a>
              <a
                className={`${linkClassName}  bg-muted border-b-1 p-4`}
                href="/services"
              >
                {t("pages.services")}
              </a>
              <a
                className={`${linkClassName}  bg-muted border-b-1 p-4`}
                href="/pricing"
              >
                {t("pages.pricing")}
              </a>
              <a
                className={`${linkClassName}  bg-muted border-b-1 p-4`}
                href="/contact"
              >
                {t("pages.contact")}
              </a>
              <div className="p-4 "></div>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </div>
  );
}

export default HeaderPage;
const LangButtonToggle = ({
  language,
  toggleLanguage,
}: {
  language: string;
  toggleLanguage: () => void;
}) => (
  <button
    onClick={toggleLanguage}
    className="flex items-center gap-2  rounded-lg p-2 transition"
  >
    {language === "ar" ? (
      <>
        <img src={uaeFlag} alt="ع" className="w-5 h-5 rounded-sm" />
        <span className="font-semibold">ع</span>
      </>
    ) : (
      <>
        <img src={usaFlag} alt="EN" className="w-5 h-5 rounded-sm" />
        <span className="font-semibold">EN</span>
      </>
    )}
  </button>
);
